module.exports = __webpack_public_path__ + "static/media/Price.4153ef80.svg";